export const State = {
  variants: [
    [
      { text: "Salom" },
      { text: "Hayr" },
      { text: "Dunyo" },
      { text: "Nima" },
      { text: "Do'stim" },
    ],
    [
      { text: "shahar" },
      { text: "Toshkent" },
      { text: "mashhur" },
      { text: "chiroyli" },
      { text: "poytaxt" },
    ],
    [
      { text: "Moskvaga" },
      { text: "Men" },
      { text: "o'qiyman" },
      { text: "boraman" },
      { text: "Moskvada" },
    ],
  ],
  trueAnswers: [
    "Salom Dunyo",
    "Toshkent chiroyli shahar",
    "Men Moskvada o'qiyman",
  ],
  questions: [
    "Hello World",
    "Tashkent is a beautiful city",
    "I study in Moskow",
  ],
};
